import FormPartnershipDetail from './FormPartnershipDetail';

export default FormPartnershipDetail;